import { render, staticRenderFns } from "./EconomicGroupClientsForm.vue?vue&type=template&id=49b33126"
import script from "./EconomicGroupClientsForm.vue?vue&type=script&lang=js"
export * from "./EconomicGroupClientsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports